import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import railyOfficerAddRequestFactory from "./add/raily-officer-add-request.factory";
import RailyOfficerAddRequest, {
  RailyOfficerAddRequestBody,
} from "./add/raily-officer-add.request";

const railyOfficerApiService = () => {
  const add = (
    request: RailyOfficerAddRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/raily-officers`;

    const body: RailyOfficerAddRequestBody =
      railyOfficerAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return { add };
};

export default railyOfficerApiService;
